<template>
  <div v-if="visible">
    <a-modal
      title="查看测试结果集"
      :width="1620"
      :visible="visible"
      :footer="null"
      @cancel="
        () => {
          $emit('cancel');
        }
      "
    >
      <div style="height: 50px" v-if="!testType">
        <!-- <a-button @click="allClick" v-if="btnShow">全选</a-button> -->
        <!-- <a-button @click="closeClick" v-else>取消全选</a-button> -->
        <a-button @click="allDel">删除</a-button>
        <a-button class="return" @click="back" v-if="!testFileList.length == 0">
          返回
        </a-button>
      </div>
      <div class="ptier" v-if="testType">
        <div
          style="display: inline-block; margin-right: 20px"
          v-for="item in testFileList"
          :key="item.key"
          class="pitem"
          @dblclick="changeTier(item.id)"
        >
          <img src="../../assets/imgs/file.png" width="60" />
          <div :title="item.name" class="Pname">{{ item.name }}</div>
        </div>
      </div>

      <div class="prtier" v-else>
        <a-card>
          <div class="divImg" v-for="item in testList" :key="item.id">
            <a-checkbox
              id="checkbox"
              style="width: 100%"
              @change="checkChange($event, item)"
            >
            </a-checkbox>

            <a-icon
              @click="delHandler(item.id)"
              class="iconDel"
              type="delete"
            />
            <div class="topBox">
              <img
                :preview="item.id"
                :width="item.fileWidth"
                :height="item.fileHeight"
                slot="cover"
                alt="example"
                :src="build(item.fileUrl)"
              />
            </div>
            <div class="fileName">
              {{ item.fileName }}
            </div>
            <!-- <a-card-meta
              class="fileName"
              :description="item.fileName"
            ></a-card-meta> -->
          </div>

          <div class="page">
            <a-pagination
              v-model="current"
              :page-size-options="pageSizeOptions"
              :total="count"
              :show-total="(total) => `共计 ${count} 项`"
              show-size-changer
              :page-size="queryData.pageSize"
              @showSizeChange="onShowSizeChange"
              @change="changePage"
            >
              <template slot="buildOptionText" slot-scope="props">
                <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                <span v-if="props.value === '50'">全部</span>
              </template>
            </a-pagination>
          </div>
        </a-card>
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as test from "@api/test_file";
import { requestUrl } from "@utils/request_url";
export default {
  name: "Check",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    testList: [],
    testFileList: [],
    testType: {
      default: false,
    },
    count: {
      type: Number,
    },
    id: "",
    current: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      // btnShow:true,
      isp: false,
      queryData: {
        pageSize: 10,
        pageIndex: 1,
        pathId: "",
        fileName: "",
      },
      list: [
        {
          name: "资源1",
          key: 1,
        },
      ],
      prList: [
        {
          name: "子资源",
          key: 1,
        },
      ],
      pageSizeOptions: ["10"],
      photoIdList: [], // 删除时图片id存储
    };
  },
  created() {
    // this.initData();
  },
  methods: {
    // allClick(){
    //   this.btnShow = false
    //   let checkBoxAll = document.getElementById('checkbox')
    //   console.log(checkBoxAll);
    //   checkBoxAll.prop('checked')
    // },
    // closeClick(){
    //   this.btnShow = true
    //   let checkBoxAll = document.getElementById('checkbox')
    //   console.log(checkBoxAll);
    //   checkBoxAll.removeProp('checked')
    // },
    // 多选删除
    allDel() {
      let that = this;
      let arr = this.photoIdList;
      this.queryData.pathId = this.id;
      if (this.photoIdList.length === 0) {
        return this.$message.error("请选择要删除的图片");
      } else {
        this.$confirm({
          title: `您确定要删除吗?`,
          okText: "确定",
          cancelText: "取消",
          onOk() {
            // test.delPhotoApi(arr).then((res) => {
            //   console.log(res);
            //   that.$message.success("删除成功");
            // });
            // that.initData();
            // that.$nextTick(() => {
            //   that.initData();
            // });
          },
        });
      }
      this.photoIdList = [];
    },
    // checkbox变化时将id添加到数组
    checkChange(e, val) {
      console.log(e, val);
      if (e.target.checked) {
        // console.log("true");
        this.photoIdList.push(val.id);
      } else {
        // console.log("false");
        this.photoIdList.splice(this.photoIdList.indexOf(val.id), 1);
      }
      console.log(this.photoIdList);
    },
    // 删除单张测试结果图片
    delHandler(id) {
      console.log(id);
      let idd = id;
      let that = this;
      this.queryData.pathId = this.id;
      this.$confirm({
        title: `您确定要删除吗?`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          // // console.log("----------------", id);
          // test.delPhotoApi([idd]).then((res) => {
          //   console.log(res);
          //   that.$message.success("删除成功");
          // });
          // // this.photoIdList = []
          // that.initData();
          // that.$nextTick(() => {
          //   that.initData();
          // });
        },
      });
    },
    // 初始化
    initData() {
      test.getTestListApi(this.queryData).then((res) => {
        console.log(res);
        this.$emit("testListChange", res.data);
        this.$previewRefresh();
        // this.testList = res.data.list;
      });
    },
    // 地址拼接
    build(value) {
      return requestUrl+"/train" + value;
    },
    // 双击点击文件夹
    changeTier(id) {
      // this.id = id;
      this.$emit("idChange", id);
      // console.log(id);
      test
        .getTestListApi({
          pageIndex: 1,
          pageSize: 10,
          pathId: id,
          fileName: "",
        })
        .then((res) => {
          console.log(res);
          this.$emit("changee", res.data);
          // this.testList = res.data.list;
          // this.count = res.data.totalRecords;
        });
      // this.testType = false;
      this.$emit("testTypeChange", false);
      this.$previewRefresh();
    },
    back() {
      // this.testType = true;
      this.$emit("testTypeChange", true);
      this.$previewRefresh();
    },
    onShowSizeChange(current, pageSize) {
      // console.log(current, pageSize);
      this.queryData.pageSize = pageSize;
      this.queryData.pageIndex = 1;
      this.queryData.pathId = this.id;
      this.initData();
      this.$previewRefresh();
    },
    changePage(page, pageSize) {
      // console.log(page, pageSize);
      this.$emit("currentChange", page);
      this.queryData.pageIndex = page;
      this.queryData.pathId = this.id;
      this.initData();
      this.$previewRefresh();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal-body {
  height: 800px;
  overflow-y: auto;
}

/deep/ .vue-directive-image-previewer-body img {
  position: absolute;
  top: 100px !important;
  height: 800px !important;
}

.Pname {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Prname {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pitem {
  width: 60px;
}
.pritem {
  width: 60px;
}
.return {
  float: right;
}
.prtier {
  width: 100%;
  height: 80%;
  .divImg {
    position: relative;
    border: 1px solid #e8e8e8;
    margin: auto;
    padding: 0 10px;

    display: inline-block;
    width: 295px;
    height: 280px;
    // max-height: 200px;
    margin-left: 5px;
    overflow: hidden;
    .iconDel {
      font-size: 18px;
      position: absolute;
      top: 5px;
      right: 10px;
      cursor: pointer;
    }
    .fileName {
      margin-top: 8px;
      height: 40px;
      line-height: 40px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .topBox {
      height: 200px;
      line-height: 200px;
      text-align: center;
      img {
        max-height: 200px;
        // width: 100%;
        // object-fit: fill;
        // height: 200px;
        // width: 100%;
      }
    }
  }
}
.page {
  text-align: right;
}
</style>